import { useQuery } from '@tanstack/react-query';
import { Service } from '@/infra/services/sandbox';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

type SandboxExistsReportParams = {
    report_type: string;
    file_id: string;
    company_id: string;
    organization_id: string;
    custom_report_id?: string;
};

export const useSandboxExistsReport = (
    params: SandboxExistsReportParams,
    options?: { enabled?: boolean }
) => {
    return useQuery(
        ['sandbox-exists-report', params],
        () => Service.existsReport(params),
        {
            enabled: (options?.enabled ?? true) &&
                !!params.file_id &&
                !!params.company_id &&
                !!params.organization_id,
            retry: false,
            refetchOnWindowFocus: false,
            onError: () => {
                message.error(I18n.get('Error on exists report'));
            }
        }
    );
};
